import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const SmallBanner = (props) => {
    const { content: { name, url } } = props;

    return (
        <div className={styles.banner}>
            <span>{name}</span>
            {
                url &&
                <span className={styles.href}>
                    <a href={url} target="_blank" rel="noreferrer">更多</a>
                    <img src="https://x0.ifengimg.com/ucms/2022_03/752418662FA3AA31AA4ECAB4A5E5690BD8159DA4_size0_w16_h16.png" alt="" />
                </span>
            }
        </div>
    );
};

SmallBanner.propTypes = {
    content: PropTypes.object
};

export default errorBoundary(SmallBanner);
